<script>
    import AudioGuideSlideShow from "./audio_guide_slideshow/AudioGuideSlideshow.svelte";
    import EventSlideshow from "./event_slideshow/EventSlideshow.svelte";

    export let onSite = false;
    console.log(onSite);
</script>

{#if onSite}
    <AudioGuideSlideShow />
{:else}
    <EventSlideshow />
{/if}
